export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23 24H1v-2h1v-7H0l3-9h5.429L11 3.797V0h5l-1 1.491L16 3h-4l3.571 3H21l3 9h-2v7h1v2zm-12-5h-1v4h1v-4zm3 0h-1v4h1v-4zm6-4H4v7h4v-5h8v5h4v-7zM5 19h2v2H5v-2zm14 0v2h-2v-2h2zM5 16h2v2H5v-2zm12 0h2v2h-2v-2zm.905-8l-1.297 1.513L12 5.564 7.392 9.513 6.095 8H4.442l-1.667 5h18.45l-1.667-5h-1.653zM12 7.5a2.5 2.5 0 010 5 2.5 2.5 0 010-5zM12 9h-.763v1.8H13V10h-1V9z\" fill=\"currentColor\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 24 24"
  }
};